// extracted by mini-css-extract-plugin
export default {"header":"SyllabusHeader_header__Hn7IA","title":"SyllabusHeader_title__4uI+n","actions":"SyllabusHeader_actions__31lYV"};